import {
  REQUEST_AGENT_SEARCHTERM,
  RECEIVE_AGENT_SEARCHTERM,
  ERROR_AGENT_SEARCHTERM,

  REQUEST_AGENT_CREATE,
  RECEIVE_AGENT_CREATE,
  ERROR_AGENT_CREATE,

  REQUEST_AGENT_RETRIEVE,
  RECEIVE_AGENT_RETRIEVE,
  ERROR_AGENT_RETRIEVE,

  REQUEST_AGENT_UPDATE,
  RECEIVE_AGENT_UPDATE,
  ERROR_AGENT_UPDATE,

  REQUEST_UNDERWRITERSEARCH_MAJORCOMPANYCODE,
  RECEIVE_UNDERWRITERSEARCH_MAJORCOMPANYCODE,
  ERROR_UNDERWRITERSEARCH_MAJORCOMPANYCODE,

  REQUEST_CUSTOMER_MAJORCOMPANIES,
  RECEIVE_CUSTOMER_MAJORCOMPANIES,
  ERROR_CUSTOMER_MAJORCOMPANIES,

  REQUEST_UNDERWRITERS_FOR_USER,
  RECEIVE_UNDERWRITERS_FOR_USER,
  ERROR_UNDERWRITERS_FOR_USER,

  REQUEST_CUSTOMER_FEATURES,
  RECEIVE_CUSTOMER_FEATURES,
  ERROR_CUSTOMER_FEATURES,

  REQUEST_CUSTOMER_SEARCH_TEXT,
  RECEIVE_CUSTOMER_SEARCH_TEXT,
  ERROR_CUSTOMER_SEARCH_TEXT,

  REQUEST_CUSTOMER_SEARCH_OPTIONS,
  RECEIVE_CUSTOMER_SEARCH_OPTIONS,
  ERROR_CUSTOMER_SEARCH_OPTIONS,

  REQUEST_CUSTOMER_DETAILS,
  RECEIVE_CUSTOMER_DETAILS,
  ERROR_CUSTOMER_DETAILS,

  REQUEST_APPRAISER_ORDER_REQUIREMENTS,
  RECEIVE_APPRAISER_ORDER_REQUIREMENTS,
  ERROR_APPRAISER_ORDER_REQUIREMENTS,

  REQUEST_UPLOAD_APPRAISER_ORDER_REQUIREMENTS,
  RECEIVE_UPLOAD_APPRAISER_ORDER_REQUIREMENTS,
  ERROR_UPLOAD_APPRAISER_ORDER_REQUIREMENTS,

  REQUEST_DELETE_APPRAISER_ORDER_REQUIREMENTS,
  RECEIVE_DELETE_APPRAISER_ORDER_REQUIREMENTS,
  ERROR_DELETE_APPRAISER_ORDER_REQUIREMENTS,
  SET_SELECTED_SURVEY_TYPE,
  SET_SELECTED_CUSTOMER,
  REQUEST_CUSTOMER_FORMS,
  RECEIVE_CUSTOMER_FORMS,
  ERROR_CUSTOMER_FORMS,
  REQUEST_NOTIFICATION_TYPES,
  RECEIVE_NOTIFICATION_TYPES,
  ERROR_NOTIFICATION_TYPES,
  REQUEST_NOTIFICATION_METHODS,
  RECEIVE_NOTIFICATION_METHODS,
  ERROR_NOTIFICATION_METHODS,
  REQUEST_NOTIFICATION_LETTERS,
  RECEIVE_NOTIFICATION_LETTERS,
  ERROR_NOTIFICATION_LETTERS,
} from '../../typeConstants';
import { customer as initialState } from '../initialState.tsx';
import { stringComparisonOrdinalCaseInsensitive } from '../../tools/sortComparisons';

const customer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_AGENT_SEARCHTERM:
      return {
        ...state,
        isFetchingAgentList: true
      };
    case RECEIVE_AGENT_SEARCHTERM:
      return {
        ...state,
        agentList: action.payload,
        isFetchingAgentList: false
      };
    case ERROR_AGENT_SEARCHTERM:
      return {
        ...state,
        isFetchingAgentList: false
      };

    case REQUEST_AGENT_CREATE:
      return {
        ...state,
        isSavingAgent: true,
      };
    case RECEIVE_AGENT_CREATE:
      {
        return {
          ...state,
          agentDetails: action.payload,
          isSavingAgent: false,
        };
      }
    case ERROR_AGENT_CREATE:
      return {
        ...state,
        isSavingAgent: false,
      };

    case REQUEST_AGENT_RETRIEVE:
      return {
        ...state,
        agentDetails: null
      };
    case RECEIVE_AGENT_RETRIEVE: {
      return {
        ...state,
        agentDetails: action.payload
      };
    }
    case ERROR_AGENT_RETRIEVE:
      return {
        ...state
      };

    case REQUEST_AGENT_UPDATE:
      return {
        ...state
      };
    case RECEIVE_AGENT_UPDATE:
      {
        // Update the search results if this item exists in it
        let agentListIndex = state.agentList.findIndex(v => {
          return v.id === action.payload.id;
        });
        let newAgentList = (agentListIndex >= 0) ? [...state.agentList] : state.agentList;
        if (agentListIndex >= 0) {
          newAgentList[agentListIndex] = {
            ...action.payload
          };
        }
        return {
          ...state,
          agentDetails: action.payload,
          agentList: newAgentList
        };
      }
    case ERROR_AGENT_UPDATE:
      return {
        ...state
      };

    case REQUEST_UNDERWRITERSEARCH_MAJORCOMPANYCODE:
      return {
        ...state
      };
    case RECEIVE_UNDERWRITERSEARCH_MAJORCOMPANYCODE:
      return {
        ...state
      };
    case ERROR_UNDERWRITERSEARCH_MAJORCOMPANYCODE:
      return {
        ...state
      };

    case REQUEST_CUSTOMER_MAJORCOMPANIES:
      return {
        ...state
      };
    case RECEIVE_CUSTOMER_MAJORCOMPANIES: {
      let sortedMajorCompanies = action.payload;
      if (action.payload.length) {
        sortedMajorCompanies = sortedMajorCompanies.sort(
          function (a, b) {
            return stringComparisonOrdinalCaseInsensitive(a.companyName, b.companyName);
          }
        );
      }
      return {
        ...state,
        majorCompanies: sortedMajorCompanies
      };
    }
    case ERROR_CUSTOMER_MAJORCOMPANIES:
      return {
        ...state
      };
    case REQUEST_UNDERWRITERS_FOR_USER:
      return {
        ...state,
        fetchingUnderwriters: true,
      };
    case RECEIVE_UNDERWRITERS_FOR_USER:
      return {
        ...state,
        underwriters: action.payload,
        fetchingUnderwriters: false,
      };
    case ERROR_UNDERWRITERS_FOR_USER:
      return {
        ...state,
        fetchingUnderwriters: false,
      };
    case REQUEST_CUSTOMER_FEATURES:
      return {
        ...state,
        fetchingEnabledFeatures: true,
      };
    case RECEIVE_CUSTOMER_FEATURES:
      return {
        ...state,
        fetchingEnabledFeatures: false,
        enabledFeatures: action.payload?.features,
      };
    case ERROR_CUSTOMER_FEATURES:
      return {
        ...state,
        fetchingEnabledFeatures: false,
      };
    case REQUEST_CUSTOMER_SEARCH_TEXT:
      return {
        ...state,
        fetchingCustomerList: true,
      };
    case RECEIVE_CUSTOMER_SEARCH_TEXT:
      return {
        ...state,
        customerList: action.payload?.searchResults,
        fetchingCustomerList: false,
      };
    case ERROR_CUSTOMER_SEARCH_TEXT:
      return {
        ...state,
        fetchingCustomerList: false,
      };
    case REQUEST_CUSTOMER_SEARCH_OPTIONS:
      return {
        ...state,
        fetchingCustomerList: true,
      };
    case RECEIVE_CUSTOMER_SEARCH_OPTIONS:
      return {
        ...state,
        customerList: action.payload?.searchResults,
        fetchingCustomerList: false,
      };
    case ERROR_CUSTOMER_SEARCH_OPTIONS:
      return {
        ...state,
        fetchingCustomerList: false,
      };
    case REQUEST_CUSTOMER_DETAILS:
      return {
        ...state,
        customerDetails: null,
        fetchingCustomerDetails: true,
      };
    case RECEIVE_CUSTOMER_DETAILS:
      return {
        ...state,
        customerDetails: action.payload,
        fetchingCustomerDetails: false,
      };
    case ERROR_CUSTOMER_DETAILS:
      return {
        ...state,
        fetchingCustomerDetails: false,
      };
    case REQUEST_APPRAISER_ORDER_REQUIREMENTS:
      return {
        ...state,
        fetchingSurveyTypeRequirements: true,
      };
    case RECEIVE_APPRAISER_ORDER_REQUIREMENTS:
      return {
        ...state,
        fetchingSurveyTypeRequirements: false,
        surveyTypeRequirements: action.payload,
      };
    case ERROR_APPRAISER_ORDER_REQUIREMENTS:
      return {
        ...state,
        fetchingSurveyTypeRequirements: false,
      };
    case REQUEST_UPLOAD_APPRAISER_ORDER_REQUIREMENTS:
      return {
        ...state,
        fetchingSurveyTypeRequirements: true,
      };
    case RECEIVE_UPLOAD_APPRAISER_ORDER_REQUIREMENTS:
      return {
        ...state,
        fetchingSurveyTypeRequirements: false,
        surveyTypeRequirements: action.payload,
      };
    case ERROR_UPLOAD_APPRAISER_ORDER_REQUIREMENTS:
      return {
        ...state,
        fetchingSurveyTypeRequirements: false,
      };
    case REQUEST_DELETE_APPRAISER_ORDER_REQUIREMENTS:
      return {
        ...state,
        fetchingSurveyTypeRequirements: true,
      };
    case RECEIVE_DELETE_APPRAISER_ORDER_REQUIREMENTS:
      return {
        ...state,
        fetchingSurveyTypeRequirements: false,
        surveyTypeRequirements: null,
      };
    case ERROR_DELETE_APPRAISER_ORDER_REQUIREMENTS:
      return {
        ...state,
        fetchingSurveyTypeRequirements: false,
      };
    case SET_SELECTED_SURVEY_TYPE:
      return {
        ...state,
        selectedSurveyType: action.payload,
      };
    case SET_SELECTED_CUSTOMER:
      return {
        ...state,
        selectedCustomerNumber: action.payload,
      };
    case REQUEST_CUSTOMER_FORMS:
      return {
        ...state,
        fetchingFormOptions: true,
      };
    case RECEIVE_CUSTOMER_FORMS:
      return {
        ...state,
        fetchingFormOptions: false,
        customerFormOptions: action.payload,
      };
    case ERROR_CUSTOMER_FORMS:
      return {
        ...state,
        fetchingFormOptions: false,
      };
    case REQUEST_NOTIFICATION_TYPES:
      return {
        ...state,
        fetchingNotificationTypes: true,
      };
    case RECEIVE_NOTIFICATION_TYPES:
      return {
        ...state,
        notificationTypes: action.payload,
        fetchingNotificationTypes: false,
      };
    case ERROR_NOTIFICATION_TYPES:
      return {
        ...state,
        fetchingNotificationTypes: false,
      };
    case REQUEST_NOTIFICATION_METHODS:
      return {
        ...state,
        fetchingNotificationMethods: true,
      };
    case RECEIVE_NOTIFICATION_METHODS:
      return {
        ...state,
        notificationMethods: action.payload,
        fetchingNotificationMethods: false,
      };
    case ERROR_NOTIFICATION_METHODS:
      return {
        ...state,
        fetchingNotificationMethods: false,
      };
    case REQUEST_NOTIFICATION_LETTERS:
      return {
        ...state,
        fetchingNotificationLetters: true,
      };
    case RECEIVE_NOTIFICATION_LETTERS:
      return {
        ...state,
        notificationLetters: action.payload,
        fetchingNotificationLetters: false,
      };
    case ERROR_NOTIFICATION_LETTERS:
      return {
        ...state,
        fetchingNotificationLetters: false,
      };
    default:
      return state;
  }
};

export default customer;
